export const LOAD_START_MARK_KEY = 'PROJECT_ARCHIVE_MODAL_LOAD_START_MARK_KEY';

export const CLOSE_BUTTON_SELECTOR =
	'div[data-test-id="project-archive-modal.ui.archive-modal.modal-footer.close-button-wrapper"]';

export const ARCHIVE_BUTTON_SELECTOR =
	'div[data-test-id="project-archive-modal.ui.archive-modal.modal-footer.archive-button-wrapper"]';
